// --- Validación + ACUMULACIÓN + PREVIEW (máx 10, 1MB c/u, tipos permitidos) ---
(function () {
  const ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];

  function setupAccumFileInput(inputId) {
    const input = document.getElementById(inputId);
    if (!input) return;

    const MAX_FILES = input.multiple ? parseInt(input.dataset.maxFiles || '10', 10) : 1;
    const MAX_SIZE = parseInt(input.dataset.maxSize || (1024 * 1024).toString(), 10);

    // Estado persistente entre cambios del mismo input
    input._selectedFiles = input._selectedFiles || [];

    // Helpers UI
    const getOrCreateEl = (id, afterEl, tag = 'small', className = 'form-help') => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement(tag);
        el.id = id;
        if (className) el.className = className;
        afterEl.insertAdjacentElement('afterend', el);
      }
      return el;
    };

    const msgEl = getOrCreateEl(`${inputId}Error`, input, 'small', 'form-help');
    const countEl = getOrCreateEl(`${inputId}Count`, msgEl, 'small', 'form-help');
    const previewEl = getOrCreateEl(`${inputId}Preview`, countEl, 'div', 'previews-grid');

    const keyOf = (f) => `${f.name}__${f.size}__${f.lastModified}`;

    function rebuildInputFilesFrom(list) {
      const dt = new DataTransfer();
      list.forEach((f) => dt.items.add(f));
      input.files = dt.files;
    }

    function renderPreviews() {
      previewEl.innerHTML = '';
      input._selectedFiles.forEach((file, idx) => {
        const card = document.createElement('div');
        card.className = 'preview-card';

        const img = document.createElement('img');
        img.alt = file.name;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `Quitar ${file.name}`);
        btn.textContent = '✕';

        btn.addEventListener('click', () => {
          // Quitar del arreglo persistente y del input
          const arr = input._selectedFiles;
          arr.splice(idx, 1);
          rebuildInputFilesFrom(arr);
          countEl.textContent = `${arr.length} / ${MAX_FILES}`;
          renderPreviews();
        });

        const fr = new FileReader();
        fr.onload = (e) => (img.src = e.target.result);
        fr.readAsDataURL(file);

        card.appendChild(img);
        card.appendChild(btn);
        previewEl.appendChild(card);
      });
    }

    input.addEventListener('change', () => {
      // Si canceló el diálogo, no tocar la selección previa
      if (!input.files || input.files.length === 0) {
        countEl.textContent = `${input._selectedFiles.length} / ${MAX_FILES}`;
        return;
      }

      const msgs = [];
      const combined = input.multiple ? [...input._selectedFiles] : [];
      const have = new Set(combined.map(keyOf));
      const incoming = Array.from(input.files);

      for (const file of incoming) {
        if (combined.length >= MAX_FILES) {
          msgs.push(`Se alcanzó el máximo de ${MAX_FILES} imágenes.`);
          break;
        }
        if (!ALLOWED.includes(file.type)) {
          msgs.push(`Archivo no permitido: ${file.name}`);
        } else if (file.size > MAX_SIZE) {
          msgs.push(`“${file.name}” supera 1 MB`);
        } else {
          const k = keyOf(file);
          if (have.has(k)) {
            msgs.push(`Archivo duplicado omitido: ${file.name}`);
          } else {
            combined.push(file);
            have.add(k);
          }
        }
      }

      // Volcar la combinación filtrada al input y al estado
      rebuildInputFilesFrom(combined);
      input._selectedFiles = combined;

      // UI
      countEl.textContent = `${combined.length} / ${MAX_FILES}`;
      if (msgs.length) {
        msgEl.textContent = `⚠️ ${msgs.join(' · ')}`;
        msgEl.style.color = '#b00020';
      } else {
        msgEl.textContent = '';
      }

      renderPreviews();
    });

    // Estado inicial
    countEl.textContent = `${input._selectedFiles.length} / ${MAX_FILES}`;
    renderPreviews();
  }

  // Crear (principal + primeras de galería)
  setupAccumFileInput('imagen');
  // Actualizar (agregar a galería)
  setupAccumFileInput('galeria');
  setupAccumFileInput('imagenes');
})();

// Inicializar cada carrusel una sola vez, después de cargar Swiper.
document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Swiper !== 'function') return;
  document.querySelectorAll('.swiper').forEach(el => {
    if (el.swiper) return;
    const options = {
      loop: el.querySelectorAll('.swiper-slide').length > 1,
      speed: 700,
      autoplay: { delay: Number(el.dataset.delay) || 3500, disableOnInteraction: false, pauseOnMouseEnter: true }
    };
    const pagination = el.querySelector('.swiper-pagination');
    if (pagination) options.pagination = { el: pagination, clickable: true };
    const prev = el.querySelector('.swiper-button-prev');
    const next = el.querySelector('.swiper-button-next');
    if (prev && next) options.navigation = { prevEl: prev, nextEl: next };
    new Swiper(el, options);
  });
}, { once: true });

// --- Dark Mode: toggle con persistencia ---
(function () {
  const BTN_SELECTOR = '.btnDark';
  const CLASS = 'dark-mode';
  const body = document.body;
  const html = document.documentElement;

  function apply(theme) {
    const isDark = theme === 'dark';
    [body, html].forEach(el => el.classList.toggle(CLASS, isDark));
    try { localStorage.setItem('theme', isDark ? 'dark' : 'light'); } catch (_) {}
  }

  function init() {
    let saved = null;
    try { saved = localStorage.getItem('theme'); } catch (_) { saved = null; }
    if (saved === 'dark' || saved === 'light') {
      apply(saved);
    } else {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      apply(prefersDark ? 'dark' : 'light');
    }
  }

  function toggle() {
    const isDark = body.classList.contains(CLASS) || html.classList.contains(CLASS);
    apply(isDark ? 'light' : 'dark');
  }

  // Delegación por si el botón se re-renderiza
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(BTN_SELECTOR);
    if (btn) toggle();
  });

  // Actualiza si cambia esquema del SO y no hay preferencia guardada
  let storedTheme = null;
  try { storedTheme = localStorage.getItem('theme'); } catch (_) {}
  if (!storedTheme && window.matchMedia) {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', (e) => apply(e.matches ? 'dark' : 'light'));
    } else if (typeof mq.addListener === 'function') { // Safari viejo
      mq.addListener((e) => apply(e.matches ? 'dark' : 'light'));
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

// --- Galería de propiedad: cambiar imagen principal al hacer clic en miniaturas ---
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.miniatura-btn');
    if (!btn) return;

    const grid = btn.closest('#galeria-miniaturas');
    const principal = document.getElementById('img-principal');
    if (!grid || !principal) return;

    const src = btn.getAttribute('data-src');
    if (!src || principal.getAttribute('src') === src) return;
 
    principal.setAttribute('src', src);

    grid.querySelectorAll('.miniatura-btn').forEach(b => {
      const active = b === btn;
      b.classList.toggle('activo', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });
})();